var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionFieldData({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "setting-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.34 5.5C12.6733 5.5 12.94 5.23333 12.94 4.9V1.8C12.94 1.46667 12.6733 1.2 12.34 1.2C12.0067 1.2 11.74 1.46667 11.74 1.8V4.9C11.74 5.22667 12.0133 5.5 12.34 5.5Z",
    fill: "var(--fill-0, #1E1341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 10.5C7.66667 10.5 7.4 10.7667 7.4 11.1V14.2C7.4 14.5333 7.66667 14.8 8 14.8C8.33333 14.8 8.6 14.5333 8.6 14.2V11.1C8.6 10.7733 8.33333 10.5 8 10.5Z",
    fill: "var(--fill-0, #1E1341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.66 5.5C3.99333 5.5 4.26 5.23333 4.26 4.9V1.8C4.26 1.46667 3.99333 1.2 3.66 1.2C3.32667 1.2 3.06 1.46667 3.06 1.8V4.9C3.06 5.22667 3.32667 5.5 3.66 5.5Z",
    fill: "var(--fill-0, #1E1341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.9 6.78H2.42C2.08667 6.78 1.82 7.04667 1.82 7.38C1.82 7.71333 2.08667 7.98 2.42 7.98H3.06V14.2C3.06 14.5333 3.32667 14.8 3.66 14.8C3.99333 14.8 4.26 14.5333 4.26 14.2V7.98H4.9C5.23333 7.98 5.5 7.71333 5.5 7.38C5.5 7.04667 5.22667 6.78 4.9 6.78Z",
    fill: "var(--fill-0, #1E1341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.58 6.78H11.1C10.7667 6.78 10.5 7.04667 10.5 7.38C10.5 7.71333 10.7667 7.98 11.1 7.98H11.74V14.2C11.74 14.5333 12.0067 14.8 12.34 14.8C12.6733 14.8 12.94 14.5333 12.94 14.2V7.98H13.58C13.9133 7.98 14.18 7.71333 14.18 7.38C14.18 7.04667 13.9133 6.78 13.58 6.78Z",
    fill: "var(--fill-0, #1E1341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.24 8.02H8.6V1.8C8.6 1.46667 8.33333 1.2 8 1.2C7.66667 1.2 7.4 1.46667 7.4 1.8V8.02H6.76C6.42667 8.02 6.16 8.28667 6.16 8.62C6.16 8.95333 6.42667 9.22 6.76 9.22H9.24C9.57333 9.22 9.84 8.95333 9.84 8.62C9.84 8.28667 9.57333 8.02 9.24 8.02Z",
    fill: "var(--fill-0, #1E1341)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_7",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionFieldData);
export default __webpack_public_path__ + "static/media/OptionFieldData.05d99c01528fe1ba26f5f41987e67991.svg";
export { ForwardRef as ReactComponent };